/**
 * Mirrors ServiceAgreementV2Status on the backend, which is what arrives in agreementStatus. The
 * schema types the field as a plain string, so there is no generated enum to import. A status the
 * backend gains but this list misses still reaches the filter through the loaded products.
 */
const KNOWN_AGREEMENT_STATUSES: string[] = [
  'INITIATED',
  'READY_FOR_CONFIGURATION',
  'IN_CONFIGURATION',
  'CONFIGURED',
  'READY_FOR_PRE_APPROVAL',
  'IN_PREAPPROVAL',
  'PRE_APPROVED',
  'PRE_APPROVAL_REJECTED',
  'REWORK_NEEDED',
  'READY_FOR_DISTRIBUTION',
  'PENDING',
  'IN_VALIDATION',
  'VALIDATION_COMPLETED',
  'READY_FOR_SETUP',
  'IN_SETUP',
  'SETUP_COMPLETE',
  'READY_FOR_APPROVAL',
  'IN_APPROVAL',
  'APPROVED',
  'CLARIFICATION_NEEDED',
  'REJECTED',
  'IN_ACTIVATION',
  'ACTIVE',
  'IN_MODIFICATION',
  'IN_CLOSING',
  'INACTIVE',
  'DELETED',
  'WITHDRAWN',
  'EXPIRED',
];

const STATUSES_HIDDEN_BY_DEFAULT: string[] = ['INACTIVE'];

export function getStatusFilterValues(statusesInData: (string | undefined | null)[]): string[] {
  const values = new Set<string>(KNOWN_AGREEMENT_STATUSES);

  statusesInData.forEach((status) => {
    if (status) values.add(status);
  });

  return Array.from(values);
}

export function getDefaultVisibleStatuses(statusesInData: (string | undefined | null)[]): string[] {
  return getStatusFilterValues(statusesInData).filter((status) => !STATUSES_HIDDEN_BY_DEFAULT.includes(status));
}
